import { Download, X } from 'lucide-react';

const MediaViewerModal = ({ src, type, closeModal }) => {
  const filename = src?.split('/').pop() || 'media';

  return (
    <div className="w-full max-w-5xl overflow-hidden rounded-xl bg-black shadow-2xl">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-white/10 bg-black/70 px-4 py-3">
        <span className="text-sm text-white/70">{type === 'image' ? 'Image preview' : 'Video preview'}</span>

        <div className="flex items-center gap-2">
          {/* Download */}
          <a
            href={src}
            download={filename}
            className="inline-flex items-center gap-1 rounded-md bg-white/10 px-3 py-1.5 text-sm text-white transition hover:bg-white/20"
          >
            <Download className="h-4 w-4" />
            Download
          </a>

          {/* Close */}
          <button onClick={closeModal} className="rounded-md p-1 text-white transition hover:bg-white/10">
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>

      {/* Media */}
      <div className="flex h-[70vh] items-center justify-center bg-black">
        {type === 'image' ? (
          <img src={src} alt="media" className="max-h-full max-w-full object-contain" />
        ) : (
          <video src={src} controls autoPlay className="max-h-full max-w-full" />
        )}
      </div>
    </div>
  );
};

export default MediaViewerModal;
